import Vue from "vue";
import { ImagePreview } from "vant";
import { DirectiveOptions } from "vue/types/umd";
import store from "@/store";
import { isObject } from "./is";
import Native from "@/common/Native";

const jump: DirectiveOptions = {
  bind(el) {
    el.onclick = function() {
      console.warn(store.state.appId);
      // 如果在app内，不跳转
      if (Native.isOpenInApp()) return;
      location.href = `http://www.cqliving.com/install/index.html?id=${store.state.appId}`;
    };
  }
};

const preview: DirectiveOptions = {
  bind(el, binding) {
    const { value } = binding;
    el.onclick = function() {
      if (!value) return;
      ImagePreview({
        images: isObject(value) ? value.images : [value],
        startPosition: isObject(value) ? value.index : 0,
        closeOnPopstate: true
      });
    };
  }
};

Vue.directive("jump", jump);
Vue.directive("preview", preview);
